import React, { Component } from 'react'

export default class File extends Component {
    componentDidMount(){
        console.log(this.props.info)
    }
    render() {
        return (
            <a href={this.props.info.remote_url} target="_blank" style={{color:"black", textDecoration:"none"}}>
                <div className="card  randal shadow">
                <img src="https://media.istockphoto.com/vectors/document-icon-vector-sign-and-symbol-isolated-on-white-background-vector-id1001154142?k=6&m=1001154142&s=170667a&w=0&h=doxVkqjfmtGwDle7TxE1W0DUUMvi3MWdMphoYX34Wm4=" style={{height: "350px", width:"300px"}} className="card-img-top" alt="..." />
                <div className="card-body">
                    <h5 className="card-title">{this.props.info.name}</h5>
                    <p className="card-text">{this.props.info.description}</p>
                </div>
            </div>
            </a>
            
        )
    }
}
